import { useTranslation } from 'react-i18next';
import { useStateContext } from '../contexts/ContextProvider';
import axiosClient from '../api/axios-client';

export const ADMIN_SUPPORTED_LOCALES = ['fr', 'en'] as const;
export type AdminLocale = (typeof ADMIN_SUPPORTED_LOCALES)[number];

export function useLocale() {
    const { i18n } = useTranslation();
    const { user, setUser } = useStateContext();

    const locale = (user?.locale as AdminLocale) || (i18n.language as AdminLocale) || 'fr';

    const changeLocale = async (next: AdminLocale) => {
        if (next === locale) return;

        await i18n.changeLanguage(next);

        if (user?.id) {
            try {
                const { data } = await axiosClient.patch('/user/locale', { locale: next });
                setUser(data);
            } catch (error) {
                console.error('Failed to persist locale', error);
            }
        }
    };

    return {
        locale,
        changeLocale,
        supportedLocales: ADMIN_SUPPORTED_LOCALES,
    };
}
